import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BroadcastService {
  constructor(private readonly router: Router) {}

  /**
   * Send a new message
   * @param message
   */
  send(message) {
    localStorage.setItem('message', JSON.stringify(message));
    localStorage.removeItem('message');
  }

  /**
   * Receive notification
   * @param ev
   */
  receive(ev) {
    if (ev?.originalEvent?.key != 'message') return;

    const message = JSON.parse(ev.originalEvent.newValue);

    if (!message) return;

    // If broadcast service sent, then process message
    if (ev?.data?.broadcastService) ev.data.broadcastService.process(message, ev);
  }

  /**
   * Process message
   * @param message
   * @param ev
   */
  process(message: any, ev: any = null) {
    // If message exists
    if (message?.action) {
      console.log(message.action);
      switch (message.action) {
        // Logout user
        case 'user.logout':
          this.router.navigate(['/entry']);
          break;

        // Default, just print message
        default:
          console.log('default: ' + message.action);
          break;
      }
    }
  }
}
